import { IMedsusCriterio } from '../../modules/types/Medsus';
import httpClient from '../httpClient';

/**
 * Busca todos os registros de critérios MedSUS.
 */
export const getAllMedsusCriterio = async (): Promise<IMedsusCriterio[]> => {
  try {
    const response = await httpClient.get('/api/medsuscriterio');
    // Backend retorna { message, registros }
    return Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];
  } catch (error: any) {
    throw new Error(
      'Erro ao obter lista de critérios MedSUS: ' + error.message,
    );
  }
};

/**
 * Busca todos os registros de critérios pelo ID do Diretriz.
 */
export const getAllMedsusCriterioByDiretrizVmp = async (
  diretrizVmpId: string,
) => {
  try {
    const response = await httpClient.get(
      `/api/medsuscriterio/diretriz/${diretrizVmpId}`,
    );
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

/**
 * Busca um critério específico pelo ID.
 */
export const getMedsusCriterioById = async (
  id: string | number,
): Promise<IMedsusCriterio> => {
  try {
    const response = await httpClient.get(`/api/medsuscriterio/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao obter critério MedSUS: ' + error.message);
  }
};

/**
 * Cria um novo critério MedSUS.
 */
export const handleCreateMedsusCriterio = async (
  form: IMedsusCriterio,
): Promise<any> => {
  try {
    const response = await httpClient.post('/api/medsuscriterio', form);
    return response.data; // { message, registro }
  } catch (error: any) {
    throw new Error('Erro ao criar critério MedSUS: ' + error.message);
  }
};

/**
 * Atualiza um critério MedSUS existente.
 */
export const handleUpdateMedsusCriterio = async (
  form: IMedsusCriterio,
): Promise<any> => {
  try {
    const response = await httpClient.patch(
      `/api/medsuscriterio/${form.id}`,
      form,
    );
    return response.data; // { message, registro }
  } catch (error: any) {
    throw new Error('Erro ao atualizar critério MedSUS: ' + error.message);
  }
};

/**
 * Realiza exclusão lógica (soft delete) de um critério MedSUS.
 */
export const handleDeleteMedsusCriterio = async (
  id: string | number,
): Promise<any> => {
  try {
    const response = await httpClient.delete(`/api/medsuscriterio/${id}`);
    return response.data; // { message }
  } catch (error: any) {
    throw new Error('Erro ao excluir critério MedSUS: ' + error.message);
  }
};
